declare namespace $ {

	type $shm_ba_summary_card__title_shm_dashboard_admin_wordstat_1 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_dashboard_admin_wordstat_2 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_wordstat['regular_tasks'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $shm_ba_summary_card__title_shm_dashboard_admin_wordstat_3 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_dashboard_admin_wordstat_4 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_wordstat['regular_items'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $shm_ba_summary_card__title_shm_dashboard_admin_wordstat_5 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_dashboard_admin_wordstat_6 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_wordstat['daily_requests'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $mol_view__sub_shm_dashboard_admin_wordstat_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_dashboard_admin_wordstat extends $mol_page {
		regular_tasks( ): string
		Regular_tasks( ): $shm_ba_summary_card
		regular_items( ): string
		Regular_items( ): $shm_ba_summary_card
		daily_requests( ): string
		Daily_requests( ): $shm_ba_summary_card
		Stats( ): $mol_view
		Settings( ): $shm_dashboard_admin_settings
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=wordstat.view.tree.d.ts.map